import { render, staticRenderFns } from "./FacsimileBundle.vue?vue&type=template&id=0882008a&lang=pug&"
import script from "./FacsimileBundle.vue?vue&type=script&lang=js&"
export * from "./FacsimileBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports